import { configureStore } from "@reduxjs/toolkit";
import { setupListeners } from "@reduxjs/toolkit/query";
import { hitlApi } from "../api/hitl-api";
import { TypedUseSelectorHook, useDispatch, useSelector } from "react-redux";
import authSlice, { listenerMiddleware } from "./slices/authSlice";
import modalsSlice from "./slices/modalsSlice";
import { gatewayApi, posApi } from "../api";
import { firebaseApi } from "../api/firebase-api";
import { zoneApi } from "../api/zone-api";
import { cartApi } from "../api/cart-api";

export const store = configureStore({
  reducer: {
    auth: authSlice,
    modals: modalsSlice,
    [hitlApi.reducerPath]: hitlApi.reducer,
    [posApi.reducerPath]: posApi.reducer,
    [gatewayApi.reducerPath]: gatewayApi.reducer,
    [firebaseApi.reducerPath]: firebaseApi.reducer,
    [zoneApi.reducerPath]: zoneApi.reducer,
    [cartApi.reducerPath]: cartApi.reducer,
  },

  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware()
      .prepend(listenerMiddleware.middleware)
      .concat(
        hitlApi.middleware,
        posApi.middleware,
        gatewayApi.middleware,
        firebaseApi.middleware,
        zoneApi.middleware,
        cartApi.middleware,
      ),
  devTools: import.meta.env.DEV,
});

// The `refetchOnFocus` and `refetchOnReconnect` options individual queries pass
// are inert until these listeners are installed once for the store. A kiosk that
// loses its uplink overnight depends on the reconnect event to refetch.
setupListeners(store.dispatch);

// Infer the `RootState` and `AppDispatch` types from the store itself
export type RootState = ReturnType<typeof store.getState>;
// Inferred type: {posts: PostsState, comments: CommentsState, users: UsersState}
export type AppDispatch = typeof store.dispatch;

export const useAppDispatch: () => AppDispatch = useDispatch;
export const useAppSelector: TypedUseSelectorHook<RootState> = useSelector;
